
import React, { useState, useEffect, useRef } from "react";
import ConversionGauge from "./admindashboardutils/components/ConversionGauge";
import ConversionBarChart from "./admindashboardutils/components/ConversionBarChart";
import CallStatisticsPie from "./admindashboardutils/components/CallStatisticsPie";
import AverageCallTime from "./admindashboardutils/components/AverageCallTime";
import QueueList from "./admindashboardutils/components/QueueList";
import { fetchCallHistory, fetchQueueData, fetchPositiveCallData } from "./admindashboardutils/utils/fetchUtils";
import { calculateConversionPercentage } from "./admindashboardutils/utils/fetchUtils";
import { BiSolidDashboard } from "react-icons/bi";
import CallHistory from "./Callhistory";
import DatePicker from "react-datepicker";
import { FaCalendarAlt } from "react-icons/fa";
import { MdRefresh,  } from "react-icons/md";

const Dashrigmo = ({ setView, user }) => {
  const [callData, setCallData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [positiveCallData, setPositiveCallData] = useState([]);
  const [activeView, setActiveView] = useState("");
  const [error, setError] = useState(null);
  const [queueData, setQueueData] = useState([]);
  const [pieData, setPieData] = useState([
    { name: "Disconnected Calls", value: 0, color: "#DC143C" },
    { name: "DNC Calls", value: 0, color: "#FFA500" },
    { name: "Positive Calls", value: 0, color: "#9ACD32" },
    { name: "Negative Calls", value: 0, color: "#FF69B4" },
  ]);
  const [averageCallTime, setAverageCallTime] = useState(0);
  const [conversionBarData, setConversionBarData] = useState([
    { day: "Mon", conversions: 0 },
    { day: "Tue", conversions: 0 },
    { day: "Wed", conversions: 0 },
    { day: "Thurs", conversions: 0 },
    { day: "Fri", conversions: 0 },
    { day: "Sat", conversions: 0 },
    { day: "Sun", conversions: 0 },
  ]);

  const today = new Date();
  const last30Days = new Date();
  last30Days.setDate(today.getDate() - 30);

  const [conversionData, setConversionData] = useState(0);
  const [startDate, setStartDate] = useState(last30Days);
  const [endDate, setEndDate] = useState(today);
  const [tempStart, setTempStart] = useState(startDate);
  const [tempEnd, setTempEnd] = useState(endDate);
  const [isOpen, setIsOpen] = useState(false);
  const datePickerRef = useRef(null);

  useEffect(() => {
    if (!user || !user.id || !user.role) {
      // setError("User information is missing. Please log in again.");
      setLoading(false);
      return;
    }
    fetchCallHistory(user, setCallData, setPieData, setAverageCallTime, setLoading, setError, startDate, endDate);
    fetchQueueData(setQueueData, setLoading, setError);
    fetchPositiveCallData(setConversionBarData, setPositiveCallData, setLoading, setError, startDate, endDate);
  }, [user, startDate, endDate]);

  useEffect(() => {
    const percentage = calculateConversionPercentage(callData);
    setConversionData(percentage);
  }, [callData]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (datePickerRef.current && !datePickerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const formattedDateRange = startDate && endDate
  ? `${startDate.toLocaleDateString("en-US", { month: "short", day: "2-digit" })} - 
     ${endDate.toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" })}`
  : "Select Date Range";

  const applyDateRange = () => {
    let newStart = tempStart || startDate;
    let newEnd = tempEnd ;
  
      if (!newEnd && newStart) {
        newEnd = new Date(today);
        // newEnd.setDate(newStart.getDate() + 30);
      }

    setStartDate(newStart);
    setEndDate(newEnd);
    setTempStart(newStart);
    setTempEnd(newEnd);
    setIsOpen(false);
    setLoading(true); 
  };

  // const handleRefresh = () => {
  //   setLoading(true);
  //   setError(null); // Optional: Clear previous errors
  //   fetchCallHistory(user, setCallData, setPieData, setAverageCallTime, setLoading, setError, startDate, endDate);
  // };
  const handleRefresh = () => {
    window.location.reload();
  };

  // const formattedDateRange =
  //   startDate && endDate
  //     ? startDate.toDateString() === endDate.toDateString()
  //       ? `${startDate.toLocaleDateString("en-US", {
  //           month: "short",
  //           day: "2-digit",
  //           year: "numeric",
  //         })}`
  //       : `${startDate.toLocaleDateString("en-US", {
  //           month: "short",
  //           day: "2-digit",
  //         })} - ${endDate.toLocaleDateString("en-US", {
  //           month: "short",
  //           day: "2-digit",
  //           year: "numeric",
  //         })}`
  //     : "Select Date Range";

  return (
    <div
      className="bg-gray-100 p-5 font-sans overflow-y-auto"
      style={{
        scrollbarWidth: "none",
        msOverflowStyle: "none",
      }}
    >
      <div className="flex bg-white text-white p-3 rounded-md mb-5">
        <div className="ml-auto flex items-center space-x-3">
        <button
              className="p-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-full border border-gray-300 transition"
              onClick={handleRefresh}
              title="Refresh Call History"
              disabled={loading}
            >
              <MdRefresh className={`text-2xl ${loading ? "animate-spin" : ""}`} />
            </button>
          <div className="relative">
            <button
              className="px-4 py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg border border-gray-300 text-sm font-medium transition flex items-center space-x-2"
              onClick={() => setIsOpen(!isOpen)}
            >
              <FaCalendarAlt className="text-gray-600 w-4 h-4" />
              <span>{formattedDateRange}</span>
            </button>
            {isOpen && (
              <div
                className="absolute right-0 mt-2 bg-white border border-gray-300 rounded-lg shadow-lg z-50 p-4"
                ref={datePickerRef}
                style={{ top: "100%", right: 0 }}
              >
                <DatePicker
                                    selected={tempStart}
                                    onChange={(dates) => {
                                      const [start, end] = dates || [null, null];
                                      setTempStart(start);
                                      setTempEnd(end);
                                      // If only start date is selected, auto-set end date to 30 days later
                                      if (start && !end) {
                                        // const autoEnd = new Date(start);
                                        // autoEnd.setDate(start.getDate() + 30);
                                        // setTempEnd(autoEnd);
                                        setTempEnd(new Date(today));
                                      }
                                    }}
                                    startDate={tempStart}
                                    endDate={tempEnd}
                                    selectsRange
                                    monthsShown={2}
                                    inline
                                    fixedHeight
                                    calendarClassName="custom-calendar"
                                  />
                                  <div className="flex justify-end mt-3">
                                  <button
                                    onClick={applyDateRange}
                                    className="px-4 py-2 bg-[#9867C5] text-white rounded-md hover:bg-purple-700 transition"
                                  >
                                    Apply
                                  </button>
                                </div>
                              </div>
                              )}
                            </div>

          <button className="px-4 py-2 h-12 shadow-lg bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-md border border-gray-300 text-sm font-medium transition flex items-center space-x-2">
            <BiSolidDashboard size={24} />
            <span>Dashboard View</span>
          </button>

          <button
            className={`px-4 py-2 h-12 shadow-lg bg-white hover:bg-gray-200 text-gray-700 rounded-md border border-gray-300 text-sm font-medium transition flex items-center space-x-2 ${
              activeView === "CallHistory" ? "bg-gray-300" : "hover:bg-gray-200"
            }`}
            onClick={() => setView("CallHistory")}
          >
            <span>Call History</span>
          </button>
          {activeView === "CallHistory" && <CallHistory />}
        </div>
      </div>

      <div className="flex justify-between space-x-5">
        <div className="flex flex-col space-y-5 w-1/3">
          <ConversionGauge conversionData={conversionData} />
          <ConversionBarChart conversionBarData={conversionBarData} />
        </div>

        <div className="flex flex-col space-y-6 w-1/3">
          <CallStatisticsPie pieData={pieData} />
          <AverageCallTime averageCallTime={averageCallTime} />
        </div>

        <div className="flex flex-col space-y-5 w-1/3">
          <QueueList queueData={queueData} />
        </div>
      </div>

      {loading && <div className="text-center text-gray-700">Loading...</div>}
      {error && <div className="text-center text-red-500">{error}</div>}
    </div>
  );
};

export default Dashrigmo;
